/* eslint-disable max-lines */
/* eslint-disable camelcase */ // TODO: to be removed in a separate PR post nextjs upgrade is complete
/* eslint-disable extra-rules/no-commented-out-code */
// 9fbef606107a605d69c0edbcd8029e5d
import logger from '@tcp/core/src/utils/loggerInstance';
import getGiftOptions from '@tcp/core/src/queries/getGiftOptions.query.graphql';
import getDefaultShippingMethods from '@tcp/core/src/queries/getDefaultShippingMethods.query.graphql';
import updateShippingMethod from '@tcp/core/src/queries/updateShippingMethod.query.graphql';
import updateShipping from '@tcp/core/src/queries/updateShipping.query.graphql';
import optinOrderUpdates from '@tcp/core/src/queries/optinOrderUpdates.query.graphql';
import getTransSmsSubscriptionState from '@tcp/core/src/queries/getTransSmsSubscriptionState.query.graphql';
import addGiftingOption from '@tcp/core/src/queries/addGiftServices.query.graphql';
import addPaymentInstruments from '@tcp/core/src/queries/updateBilling.query.graphql';
import getShipmentMethods from '@tcp/core/src/queries/getShippingMethods.query.graphql';
import CacheConfiguration from '@tcp/core/src/services/handler/graphQL/clients/retryConfiguration';
import submitOrderQuery from '@tcp/core/src/queries/submitOrder.query.graphql';
import appleVenmoSubmitOrderQuery from '@tcp/core/src/queries/appleVenmoSubmitOrder.query.graphql';
import getCartCachedQuery from '@tcp/core/src/queries/getCartCached.query.graphql';
import { checkCache, readCookie } from '@tcp/core/src/utils';
import {
  getGifCardDetailsFormatter,
  getOrderItemFormatter,
} from '@tcp/core/src/services/abstractors/SFCC/CartItemTile';
import getExpressCheckoutQuery from '@tcp/core/src/queries/expressCheckout.query.graphql';
import moveItemToSfl from '@tcp/core/src/queries/moveItemsToSFL.query.graphql';
import {
  hasGiftOptionWithPromotion,
  updateKeyWithValue,
} from '@tcp/core/src/services/abstractors/SFCC/ApplyCoupon.js';
import {
  FREE_GIFT_WRAPPING,
  IS_APPLIED_TO_BASKET,
  IS_ON_HOLD,
} from '@tcp/core/src/components/features/CnC/common/organism/CouponAndPromos/Coupon.constants.js';
import getLoyaltyBenefits from '@tcp/core/src/queries/getLoyaltyBenefits.query.graphql';
import { flatCurrencyToCents } from './CartItemTile';
import { parseDate } from '../../../utils/parseDate';
import { executeStatefulGraphQLQuery, executeStatefulAPICall } from '../../handler';
import { getAPIConfig } from '../../../utils';
import endpoints from '../../endpoints';

import {
  responseContainsErrors,
  ServiceResponseError,
  getFormattedError,
  graphQlErrorHandler,
} from '../../../utils/errorMessage.util';
import CheckoutConstants from '../../../components/features/CnC/Checkout/Checkout.constants';
import {
  CARD_NAME_MAPPING,
  CARD_TYPES,
} from '../../../components/features/CnC/SinglePageCheckout/container/SinglePageCheckout.constants';
import { setApplePaymentInProgress } from '../../../components/features/CnC/Checkout/container/Checkout.action';

const RES_NULL_ERROR = 'res body is null';

const shippingMethodResponseHandler = (res) => {
  if (responseContainsErrors(res)) {
    throw new ServiceResponseError(res);
  }
  const { applicableShippingMethods: methods, defaultShippingMethodId } =
    res.data.getDefaultShippingMethods || res.data.getShippingMethods;

  let hasDefault = false;

  const resFiltered = Object.keys(methods).map((index) => {
    const { description: shippingMethod, price, name: displayName } = methods[index];

    const isDefault = defaultShippingMethodId === methods[index].id;
    hasDefault = hasDefault || isDefault;

    return {
      id: methods[index].id,
      displayName: (displayName || '').trim(),
      shippingSpeed: (shippingMethod || '')?.split('-')[1]?.trim(),
      price: price ? parseFloat(price, 10) : 0,
      code: methods[index].c_code,
      isDefault,
    };
  });

  if (!hasDefault && methods.length) resFiltered[0].isDefault = true;

  return resFiltered;
};

export const getShippingMethods = (address, labels, eventType, cacheTTL) => {
  const {
    state,
    zipCode: zipcode,
    addressField1 = '',
    addressField2: address2,
    addressLine1,
    country,
  } = address;
  const address1 = !addressField1 && addressLine1 ? addressLine1 : addressField1;

  let variables = {};
  if (eventType === CheckoutConstants.CHANGE_SHIPMMENT_METHODS) {
    variables = {
      ...variables,
      state,
      zipcode,
      address1,
      address2,
      country,
    };
  }
  Object.keys(variables).forEach((key) => {
    if (!variables[key]) delete variables[key];
  });

  const isLoadShipmentMethod = eventType === CheckoutConstants.LOAD_SHIPMMENT_METHODS;
  let payload = { variables };

  if (isLoadShipmentMethod) {
    const { preFix: cacheConfigKey, defaultTTL } = CacheConfiguration.GET_DEFAULT_SHIPPING_METHODS;
    payload = {
      ...payload,
      query: getDefaultShippingMethods,
      cacheConfigKey,
      TTL: cacheTTL || defaultTTL,
    };
  } else {
    payload = { ...payload, query: getShipmentMethods, fetchPolicy: 'no-cache' };
  }

  return executeStatefulGraphQLQuery({
    ...payload,
  })
    .then(shippingMethodResponseHandler)
    .catch((err) => {
      const formattedErrorReq = { errorResponse: err[0] };
      throw getFormattedError(formattedErrorReq, labels, true);
    });
};

const giftWrappingOptionResponseHandler = (res) => {
  const options =
    (res && res.data && res.data.getGiftOptions && res.data.getGiftOptions.setProducts) || [];
  const giftOptions = options.map((option) => {
    const {
      name,
      price,
      shortDescription: longDescription,
      id: catEntryId,
      brand: itemBrand,
    } = option;

    return {
      catEntryId,
      itemBrand,
      name,
      price,
      longDescription,
    };
  });

  return {
    body: { giftOptions },
    text: JSON.stringify({ giftOptions }),
  };
};

export const handleAfterpaychckout = (token) => {
  const payload = {
    header: {
      token,
    },
    webService: endpoints.afterPayCheckout,
  };
  return executeStatefulAPICall(payload)
    .then((res) => {
      const response = res.body;
      if (!response) {
        throw new Error('res body is null');
        // TODO - Set API Helper to filter if error exists in response
      }
      return { response };
    })
    .catch(() => {
      throw new Error('Something went wrong');
    });
};

export const getGiftWrappingOptions = (cacheTTL) => {
  const { preFix: cacheConfigKey, defaultTTL } = CacheConfiguration.GET_GIFT_OPTIONS;
  return executeStatefulGraphQLQuery({
    query: getGiftOptions,
    cacheConfigKey,
    TTL: cacheTTL || defaultTTL,
  }).then(giftWrappingOptionResponseHandler);
};

const executeUpdateShippingCall = (payload) => {
  return executeStatefulGraphQLQuery(payload)
    .then((res) => {
      if (responseContainsErrors(res)) {
        throw new ServiceResponseError(res);
      } else {
        const shippingMethodResp = res.data && res.data.updateShippingMethod;
        return {
          success: true,
          shippingMethodResp,
        };
      }
    })
    .catch((err) => {
      throw getFormattedError(err, {});
    });
};

export function setSMSUpdates(payloadData) {
  const payload = {
    query: optinOrderUpdates,
    variables: {
      optinUpdatesForOrderRequestDTO: { optinUpdatesForOrderList: payloadData.payload },
    },
    type: 'mutation',
  };

  return executeStatefulGraphQLQuery(payload)
    .then((res) => {
      if (responseContainsErrors(res)) {
        throw new ServiceResponseError(res);
      } else {
        return res;
      }
    })
    .catch((err) => {
      throw getFormattedError(err, {});
    });
}

export function getTransSmsStatus(payloadData) {
  const payload = {
    query: getTransSmsSubscriptionState,
    variables: {
      phoneNumber: payloadData,
    },
  };

  return (
    executeStatefulGraphQLQuery(payload)
      // eslint-disable-next-line sonarjs/no-identical-functions
      .then((res) => {
        if (responseContainsErrors(res)) {
          throw new ServiceResponseError(res);
        } else {
          return res;
        }
      })
      .catch((err) => {
        throw getFormattedError(err, {});
      })
  );
}

// eslint-disable-next-line complexity
export const updateQuery = (cache, data) => {
  const cartData =
    data &&
    (data.updateShippingMethod ||
      data.updateShipping ||
      data.addPaymentInstruments ||
      data.addGiftOptionToBasket);
  if (!cartData) {
    return;
  }
  const {
    orderTotal,
    productSubTotal,
    productTotal,
    shippingTotal,
    shippingTotalTax,
    taxTotal,
    productItems,
    c_giftPrice,
    c_giftDiscount,
    pointsToRedeem,
    c_giftMessage,
    c_productTotalWithOutGift,
    c_promotionTotal,
    c_earnPlaceProximity,
    c_earnPlaceCashAmount,
    c_earnPlaceCashCoupon,
    c_couponTotal,
    c_totalSavings,
  } = cartData;
  const dataToUpdate = {
    orderTotal,
    productSubTotal,
    productTotal,
    shippingTotal,
    shippingTotalTax,
    taxTotal,
    c_giftPrice,
    c_giftDiscount,
    pointsToRedeem,
    c_couponTotal,
    c_totalSavings,
    c_giftMessage,
    c_productTotalWithOutGift,
    c_promotionTotal,
    c_earnPlaceProximity,
    c_earnPlaceCashAmount,
    c_earnPlaceCashCoupon,
  };
  if (productItems) {
    dataToUpdate.productItems = productItems;
  }
  let isCacheExist = false;
  if (dataToUpdate) {
    isCacheExist = checkCache(cache);
  }
  if (isCacheExist) {
    const storedData = cache.readQuery({ query: getCartCachedQuery });
    cache.writeQuery({
      query: getCartCachedQuery,
      data: { getCart: { ...storedData.getCart, ...dataToUpdate } },
      // broadcast: false,
    });
  }
};

export const getValueFromResponse = (benefits, type, keyName) => {
  const benefit = benefits.find((item) => item?.type === type);
  return benefit ? benefit[keyName] : null;
};

export const updateQueryForLoyaltyBenefits = (cache, data) => {
  const cartData =
    data &&
    (data.updateShippingMethod ||
      data.updateShipping ||
      data.addPaymentInstruments ||
      data.addGiftOptionToBasket);
  if (!cartData) {
    return;
  }
  const {
    orderTotal,
    productSubTotal,
    productTotal,
    shippingTotal,
    shippingTotalTax,
    taxTotal,
    productItems,
    c_giftPrice,
    c_giftDiscount,
    pointsToRedeem,
    c_giftMessage,
    c_productTotalWithOutGift,
    c_promotionTotal,
    c_earnPlaceProximity,
    c_earnPlaceCashAmount,
    c_earnPlaceCashCoupon,
    c_couponTotal,
    c_totalSavings,
  } = cartData;
  const dataToUpdate = {
    orderTotal,
    productSubTotal,
    productTotal,
    shippingTotal,
    shippingTotalTax,
    taxTotal,
    c_giftPrice,
    c_giftDiscount,
    pointsToRedeem,
    c_couponTotal,
    c_totalSavings,
    c_giftMessage,
    c_productTotalWithOutGift,
    c_promotionTotal,
    c_earnPlaceProximity,
    c_earnPlaceCashAmount,
    c_earnPlaceCashCoupon,
  };
  if (productItems) {
    dataToUpdate.productItems = productItems;
  }
  let isCacheExist = false;
  let isBonusDayCacheExist = false;
  if (dataToUpdate) {
    isCacheExist = checkCache(cache);
    isBonusDayCacheExist = checkCache(cache, 'getLoyaltyBenefits');
  }

  if (isBonusDayCacheExist) {
    const isFreeGiftWrapping = hasGiftOptionWithPromotion(data?.addGiftOptionToBasket.productItems);
    let benefits = {};
    try {
      benefits = JSON.parse(data?.addGiftOptionToBasket?.benefits || '{}');
    } catch (e) {
      console.error('Failed to parse benefits:', e);
    }
    const isGiftwrapperApplied = benefits?.FreeGiftWrap;
    const storedData = cache.readQuery({ query: getLoyaltyBenefits });
    let updateData = storedData.getLoyaltyBenefits;
    if (isGiftwrapperApplied) {
      const isOnHold = !isFreeGiftWrapping;
      updateData = updateKeyWithValue(updateData, FREE_GIFT_WRAPPING, isOnHold, IS_ON_HOLD);

      if (!isOnHold) {
        updateData = updateKeyWithValue(updateData, FREE_GIFT_WRAPPING, true, IS_APPLIED_TO_BASKET);
      }
    }

    cache.writeQuery({
      query: getLoyaltyBenefits,
      data: { getLoyaltyBenefits: updateData },
    });
  }

  if (isCacheExist) {
    const storedData = cache.readQuery({ query: getCartCachedQuery });

    cache.writeQuery({
      query: getCartCachedQuery,
      data: { getCart: { ...storedData.getCart, ...dataToUpdate } },
      // broadcast: false,
    });
  }
};
export function setShippingMethodAndAddressId(shippingTypeId) {
  const payload = {
    query: updateShippingMethod,
    variables: {
      shippingMethodId: { id: shippingTypeId },
    },
    type: 'mutation',
    updateQuery,
  };

  return executeUpdateShippingCall(payload);
}

export function updateShippingAddressMethodAndGiftOption(
  updateShippingShippingRequestDto,
  errorMapping = {}
) {
  const payload = {
    query: updateShipping,
    variables: {
      updateShippingShippingRequestDto,
    },
    type: 'mutation',
    updateQuery,
  };

  return executeStatefulGraphQLQuery(payload)
    .then((res) => {
      return res;
    })
    .catch((err) => {
      if (err?.[0]?.errorMessage === CheckoutConstants.CHECKOUT_ERROR_MESSAGE) {
        throw err;
      } else {
        setApplePaymentInProgress(false);
        throw graphQlErrorHandler(err, errorMapping);
      }
    });
}

const getUpdateQueryFunctionForUpdateGiftServices = (isLoyaltyTieringEnabled) => {
  if (isLoyaltyTieringEnabled) return updateQueryForLoyaltyBenefits;
  return updateQuery;
};
export function updateGiftServices(
  addGiftOptionRequestDTO,
  errorMapping = {},
  isLoyaltyTieringEnabled = false
) {
  const updateQueryFunction = getUpdateQueryFunctionForUpdateGiftServices(isLoyaltyTieringEnabled);

  const payload = {
    query: addGiftingOption,
    variables: {
      addGiftOptionRequestDTO,
    },
    type: 'mutation',
    updateQuery: updateQueryFunction,
  };

  return executeStatefulGraphQLQuery(payload)
    .then((res) => {
      const data = res?.data;
      return {
        data,
        isLoyaltyBenefitsCacheUpdate: isLoyaltyTieringEnabled,
      };
    })
    .catch((err) => {
      const errorResponse = err?.[0] || err;
      if (errorMapping[errorResponse?.errorCode]) {
        errorResponse.errorMessage = errorMapping[errorResponse?.errorCode];
      }
      throw errorResponse;
    });
}

export const getPaymentInstruction = (
  cardDetails,
  isMaskedCard,
  paySecureSessionId,
  isPLCC,
  isGuestUser,
  afterpay,
  recaptchaToken
  // eslint-disable-next-line sonarjs/cognitive-complexity
) => {
  let paymentInstrument;
  if (isPLCC) {
    paymentInstrument = {
      cardNumber: cardDetails.accountNo,
    };
  } else {
    const expMonth = cardDetails.expMonth.toString();
    const expirationMonth = expMonth.length === 1 ? `0${expMonth}` : expMonth;
    paymentInstrument = isMaskedCard
      ? {
          cardNumber: cardDetails.accountNo,
          cvv: cardDetails.cvv,
          expirationMonth,
          expirationYear: cardDetails?.expYear?.toString(),
          recaptchaToken,
        }
      : {
          sessionId: paySecureSessionId,
        };
  }

  if (!isGuestUser && !afterpay) {
    paymentInstrument.saveToProfile = cardDetails.saveToAccount;
    if (cardDetails.saveToAccount) {
      paymentInstrument.isDefaultPayment = cardDetails.isDefault;
    }
  }

  if (cardDetails.creditCardId) {
    if (cardDetails.c_savedPI) {
      paymentInstrument.c_savedPI = cardDetails.c_savedPI;
    } else {
      paymentInstrument.paymentInstrumentId = cardDetails.creditCardId;
    }
  }

  if (afterpay) {
    paymentInstrument.afterPay = 'true';
  }

  const type = isPLCC ? 'PLCC' : 'CC';
  paymentInstrument = { ...paymentInstrument, type };
  return paymentInstrument;
};

export function addPaymentInstruction(
  billingAddress,
  paymentInfo = null,
  errorsMapping,
  recaptchaToken
) {
  const {
    addressId,
    firstName,
    lastName,
    addressLine1: address1,
    addressLine2: address2,
    city,
    state: stateCode,
    country: countryCode,
    zipCode,
    addressType,
    phoneNumber,
    phone,
    emailAddress,
    sameAsShippingAddress,
    zipCodeInternational,
  } = billingAddress;

  const postalCode = zipCode || zipCodeInternational;

  const formattedBillingAddress = {
    firstName,
    lastName,
    address1,
    address2,
    city,
    stateCode,
    countryCode,
    postalCode,
    c_addressId: addressId,
    c_addressType: addressType,
    c_sameAsShippingAddress: !!sameAsShippingAddress,
  };

  if (phoneNumber || phone) {
    formattedBillingAddress.phone = phoneNumber || phone;
  }

  if (emailAddress) {
    formattedBillingAddress.c_emailAddress = emailAddress;
  }

  let paymentInstrument = {};
  if (paymentInfo) {
    paymentInstrument = { paymentInstrument: paymentInfo };
  }

  const payload = {
    query: addPaymentInstruments,
    variables: {
      billingPayload: {
        billingAddress: formattedBillingAddress,
        ...paymentInstrument,
        recaptureResponse: recaptchaToken,
      },
    },
    type: 'mutation',
    updateQuery,
  };

  return executeStatefulGraphQLQuery(payload)
    .then((res) => {
      const billingMethodResp = res.data && res.data.addPaymentInstruments;
      return {
        billingMethodResp,
      };
    })
    .catch((err) => {
      throw graphQlErrorHandler(err, errorsMapping);
    });
}

export const addPIOfflineToSFCC = (cardDetails, isMaskedCard) => {
  let cardNumber = {};
  if (!isMaskedCard) {
    cardNumber = { number: cardDetails.accountNo };
  }
  const payload = {
    body: {
      payment_card: {
        card_type: CARD_NAME_MAPPING[cardDetails.cardType],
        security_code: cardDetails.cvv,
        expiration_year: parseInt(cardDetails.expYear, 10),
        expiration_month: parseInt(cardDetails.expMonth, 10),
        ...cardNumber,
      },
      payment_method_id: CARD_TYPES.CREDIT_CARD,
      c_paySecureFailed: true,
    },
    webService: endpoints.creditCardOffline,
  };
  return executeStatefulAPICall(payload, null, true)
    .then((res) => res)
    .catch((err) => {
      throw getFormattedError(err, []);
    });
};

const getPaymentList = (orderDetails) => {
  if (orderDetails.paymentInstruments && orderDetails.paymentInstruments[0]) {
    return orderDetails.paymentInstruments.map(
      ({
        amount,
        paymentMethodId,
        afterPay,
        paymentCard = '',
        paySecureFailed,
        c_adyenPaymentMethod,
      }) => ({
        authorizedAmount: amount,
        paymentMethodId,
        afterpay: afterPay,
        paymentMethod: paymentCard?.cardType || paymentMethodId,
        isPaySecureFailed: paySecureFailed,
        adyenPaymentMethod: c_adyenPaymentMethod,
      })
    );
  }
  return [];
};

const getPromotionTotal = (orderSummary) => {
  let promotionTotal = flatCurrencyToCents(orderSummary.c_promotionTotal || 0);
  if (promotionTotal < 0) {
    promotionTotal *= -1;
  }
  return promotionTotal;
};

const getOrderConfirmationDetails = ({
  orderSummary,
  orderDetails,
  sthLinkOrder,
  productItems,
  paymentList,
  orderItems,
  totalItems,
  submitOrder,
}) => {
  let couponsTotal = flatCurrencyToCents(orderSummary.c_couponTotal || 0);
  if (couponsTotal < 0) {
    couponsTotal *= -1;
  }
  const promotionTotal = getPromotionTotal(orderSummary);
  const { giftCardsTotal } = getGifCardDetailsFormatter(orderSummary);
  return {
    summary: {
      itemsTotal: orderSummary.orderTotal,
      itemsCount: totalItems,
      giftCardsTotal,
      giftWrappingTotal: flatCurrencyToCents(orderSummary.c_giftPrice) || 0,
      giftDiscountTotal: flatCurrencyToCents(orderSummary.c_giftDiscount) || 0,
      pointsToRedeem: orderSummary.pointsToRedeem || '0',
      taxesTotal: flatCurrencyToCents(orderSummary.taxTotal) || 0,
      shippingTotal: flatCurrencyToCents(orderSummary.shippingTotal),
      subTotal: flatCurrencyToCents(orderSummary.c_productTotalWithOutGift || 0),
      grandTotal: orderSummary.orderTotal,
      totalOrderSavings: flatCurrencyToCents(orderSummary.c_totalSavings || 0),
      subTotalWithDiscounts: flatCurrencyToCents(orderSummary.orderSubTotalDiscount || 0),
      valueOfEarnedPcCoupons: parseInt(orderSummary.c_earnPlaceCashAmount || 0, 10),
      couponsTotal: couponsTotal < 0 ? 0 : couponsTotal,
      savingsTotal: promotionTotal || 0,
    },

    isOrderPending: paymentList.some((payment) => payment.isPaySecureFailed === true),
    holdDate: null,
    totalsByFullfillmentCenterMap: null,

    orderDetails: {
      date: parseDate(orderSummary.creationDate),
      orderNumber: orderSummary ? submitOrder.orderNo : CheckoutConstants.NOT_AVAILABLE,
      trackingLink: sthLinkOrder,
      orderTotal: orderSummary.orderTotal,
      productTotal: orderSummary?.productTotal,
    },
    rewardedPoints: orderDetails.estimatedPointsEarned,
    isElectiveBonus: orderDetails.isElectiveBonus,
    currencyCode: orderDetails.currencyCode,
    productItems,
    orderItems,
    paymentsList: paymentList,
    billing: orderSummary?.billingAddress || null,
  };
};

const getConfirmationShipping = ({
  shipping,
  sthOrderPlaced,
  sthLinkOrder,
  sthTotalOrder,
  sthItemCount,
}) =>
  (shipping && {
    address: {
      firstName: shipping.firstName,
      lastName: shipping.lastName,
    },
    emailAddress: shipping.email1,
    // encryptedEmailAddress: encodeURIComponent(shipping.encryptedEmail1),
    orderDate: sthOrderPlaced,
    orderLink: sthLinkOrder,
    orderTotal: sthTotalOrder,
    itemsCount: sthItemCount,
  }) ||
  undefined;

const updateOrderDetail = ({
  orderConfirmationDetails: orderConfirmationDetails1,
  orderSummary,
  shipping,
  sthOrderPlaced,
  sthLinkOrder,
  sthTotalOrder,
  sthItemCount,
}) => {
  const orderConfirmationDetails = orderConfirmationDetails1;
  const giftWrapItem = orderSummary.giftWrapItem && orderSummary.giftWrapItem[0];
  if (giftWrapItem) {
    orderConfirmationDetails.summary.giftWrappingTotal = flatCurrencyToCents(
      giftWrapItem.totalPrice
    );
    orderConfirmationDetails.summary.subTotal -=
      orderConfirmationDetails?.summary?.giftWrappingTotal;
  }

  orderConfirmationDetails.shipping = getConfirmationShipping({
    shipping,
    sthOrderPlaced,
    sthLinkOrder,
    sthTotalOrder,
    sthItemCount,
  });
};

const getOrderSummary = (addCheckoutResponse, submitOrderResp) => {
  return addCheckoutResponse ? addCheckoutResponse.submitOrderResp : submitOrderResp;
};

const getConformationUserDetail = ({ shipping, orderConfirmationDetails }) => {
  return {
    emailAddress:
      shipping.c_emailAddress ||
      (orderConfirmationDetails.shipping ? orderConfirmationDetails?.shipping?.emailAddress : null),
    encryptedEmailAddress:
      encodeURIComponent(shipping.encryptedEmail1) ||
      (orderConfirmationDetails.shipping
        ? orderConfirmationDetails.shipping.encryptedEmailAddress
        : null),
    city: shipping?.city,
    state: shipping?.stateCode,
    zipCode: shipping?.postalCode,
    country: shipping?.countryCode,
    firstName: shipping?.firstName,
    lastName: shipping?.lastName,
    phoneNumber: shipping?.phone,
  };
};

export const handleSubmitOrderResponse = (res, isLoyaltyTieringEnabled = false) => {
  if (responseContainsErrors(res)) {
    throw new ServiceResponseError(res);
  }
  const { addCheckoutResponse, submitOrder } = res.data;
  const orderSummary = getOrderSummary(addCheckoutResponse, submitOrder);
  const orderDetails = orderSummary.orderDetailsResponse || orderSummary;
  const shipping = orderSummary?.shipments[0]?.shippingAddress || null;
  const shipments = orderSummary?.shipments;
  const sthOrderId = submitOrder.orderNo;
  const sthTotalOrder = flatCurrencyToCents(orderSummary.paymentInstruments[0].amount);
  const apiConfig = getAPIConfig();
  const trackingLinkPrefix = `${CheckoutConstants.TRACKING_LINK_PREFIX_CONSTANT}?catalogId=${apiConfig.catalogId}&langId=${apiConfig.langId}&storeId=${apiConfig.storeId}`;
  const sthLinkOrder = `${trackingLinkPrefix}&shipmentTypeId=${
    CheckoutConstants.SHIPMENT_TYPE_ID
  }&forSearch=${CheckoutConstants.FOR_SEARCH}&orderId=${sthOrderId}&emailId=${
    encodeURIComponent(shipping.encryptedEmail1) || ''
  }`;
  const paymentList = getPaymentList(orderDetails);
  const productItems = orderDetails.productItems || [];
  orderSummary.orderType = 'ECOM';
  const { totalItems, orderItems } = getOrderItemFormatter(orderDetails);
  const sthItemCount = totalItems;
  const orderConfirmationDetails = getOrderConfirmationDetails({
    orderSummary,
    orderDetails,
    trackingLinkPrefix,
    sthLinkOrder,
    productItems,
    paymentList,
    orderItems,
    totalItems,
    submitOrder,
  });

  if (orderDetails.airMiles) {
    orderConfirmationDetails.airmiles = {
      accountNumber: orderDetails?.airMiles?.airMilesAccount,
      promoId: orderDetails?.airMiles?.airMilesDeal,
    };
  }

  if (isLoyaltyTieringEnabled && orderDetails?.benefits) {
    const benefitsObj = JSON.parse(orderDetails?.benefits);
    orderConfirmationDetails.isElectiveBonus = benefitsObj?.BonusPoint;
  }

  if (orderConfirmationDetails.summary.savingsTotal < 0) {
    orderConfirmationDetails.summary.savingsTotal = 0;
  }

  updateOrderDetail({
    orderConfirmationDetails,
    orderSummary,
    shipping,
    sthLinkOrder,
    sthTotalOrder,
    sthItemCount,
  });
  const orderNoArray = shipments.map((a) => a.c_orderNo != null && a.c_orderNo);

  // Information needed for guest user registration on confirmation page
  orderConfirmationDetails.userDetails = getConformationUserDetail({
    shipping,
    orderConfirmationDetails,
  });
  orderConfirmationDetails.shipments = shipments;
  orderConfirmationDetails.c_sthOrderNo = orderSummary?.c_sthOrderNo || orderSummary?.orderNo;
  orderConfirmationDetails.orderNoArray = orderNoArray;

  // SFCC-TODO update PaymentList
  // orderDetails.paymentsList.forEach(payment => {
  //   if (orderDetails.paymentInstruments[0].paymentCard.cardType !== 'GC' && payment.billingAddressDetails) {
  //     const billingAddress = payment.billingAddressDetails;
  //     orderConfirmationDetails.userDetails = getUserDetailForGC(
  //       billingAddress,
  //       orderConfirmationDetails,
  //       addressDetails
  //     );
  //   }
  // });

  // FIXME: should come from backend / variable days
  const holdDate = parseDate(orderDetails.creationDate);
  holdDate.setDate(holdDate.getDate() + 4);
  orderConfirmationDetails.holdDate = holdDate;
  return orderConfirmationDetails;
};

export function submitOrderFn(
  errorsMapping = [],
  adyenRequest,
  actions,
  isLoyaltyTieringEnabled,
  orderBenefitsDTO
) {
  return executeStatefulGraphQLQuery({
    query: submitOrderQuery,
    type: 'mutation',
    header: {},
    variables: { adyenRequest, orderBenefitsDTO },
  })
    .then((res) => {
      if (actions) actions.resolve({ resultCode: 'Authorised' });
      return handleSubmitOrderResponse(res, isLoyaltyTieringEnabled);
    })
    .catch((err) => {
      if (actions) actions.reject();
      logger.error('Error in addCheckout API call', {
        extraData: {
          errorMessage: JSON.stringify(err),
          component: 'CheckoutSFCC - submitOrderFn',
        },
      });
      throw graphQlErrorHandler(err, errorsMapping);
    });
}

export function appleVenmoSubmitOrderFn(payload, errorsMapping = [], orderBenefitsDTO) {
  const basketId = readCookie('basketId');
  return executeStatefulGraphQLQuery({
    variables: {
      basketId,
      btRequest: payload,
      orderBenefitsDTO,
    },
    query: appleVenmoSubmitOrderQuery,
    type: 'mutation',
  })
    .then((resp) => {
      if (!resp.data) {
        throw new Error(`Error in addCheckout API call`);
      }
      return handleSubmitOrderResponse(resp);
    })
    .catch((err) => {
      logger.error(`Error in addCheckout API call: ${err}`);
      throw graphQlErrorHandler(err, errorsMapping);
    });
}

export const isGiftItem = (itemID, productItems) => {
  const productItem = productItems.find((item) => item.itemId === itemID);
  return productItem?.c_giftItem || false;
};

// eslint-disable-next-line sonarjs/cognitive-complexity
export function requestPersonalizedCouponsFn({
  orderNumber,
  emailAddress,
  locationId,
  couponList = [],
  isElectiveBonus,
  currencyCode,
  payments = [],
  cartItems = [],
  productItems = [],
  isGuestUser,
  mprData,
  token,
  associateId,
  ...eddItemLevelInfo
}) {
  const cartItemList = cartItems.map((item) => ({
    price: item.itemInfo.itemUnitDstPrice,
    orderItemId: item.itemInfo.itemId,
    itemUnitPrice: item.itemInfo.itemUnitPrice,
    transactionType: CheckoutConstants.TRANSACTION_TYPE,
    productSku: item.productInfo.variant,
    quantity: item.itemInfo.quantity,
    productVariant: item.productInfo.variant,
    isGiftItem: isGiftItem(item.itemInfo.itemId, productItems),
  }));

  let mprId = CheckoutConstants.GUEST_USER_ID;
  if (!isGuestUser && mprData !== '' && mprData !== undefined) {
    mprId = mprData;
  }

  const paymentsList = payments.map((payment) => {
    const temp = {
      authorizedAmount: payment.authorizedAmount,
      paymentMethod: payment.paymentMethod,
    };
    // Checking if the PLCC hash has some value only then sending this parameter in header else
    // back end code will break, as usual.
    if (payment.plccHash) {
      temp.plccHash = payment.plccHash;
    }
    return temp;
  });
  const couponsList = couponList.map((coupon) => ({
    couponCode: coupon.id,
  }));

  const payload = {
    body: {
      personalizedOffersRequest: {
        externalTransactionId: orderNumber,
        channelId: 'ECOMM_WEBSITE',
        langauge: 'EN',
        scenario: CheckoutConstants.COUPON_SCENARIO_CODE, // hard coded as per backend
        order: {
          isElectiveBonus,
          currencyCode,
          store: {
            location: locationId,
          },
          customer: {
            customerLookupType: CheckoutConstants.COUPON_CUSTOMER_LOOKUP_TYPE,
            customerLookupId: emailAddress,
            customerType: associateId ? 'ASSOCIATE' : 'REGULAR',
          },
          coupon: couponsList,
          lineItem: cartItemList,
        },
        paymentsList,
        mprId,
        afterPayToken: token,
        eddItemLevelInfo,
      },
    },
    webService: endpoints.updatedPersonalizedCoupons,
  };

  return executeStatefulAPICall(payload, getFormattedError, true)
    .then((res) => {
      /**
       * Scenarios Summary:
       * Coupons data is recieved in personalizedOffersResponse, Brierly is recieved in orderResponse
       * When ODM service is down, Back end is sending error of ODM in personalizedOffersResponse, and orderResponse is still available
       * When WCS is down/fails, error is recieved in root of response
       */

      // When WCS is down, (both personalizedOffersResponse and orderResponse are not available), error recieved in root of response
      if (responseContainsErrors(res)) {
        throw new ServiceResponseError(res);
      }

      const responseObj = {};

      if (res?.body?.data) {
        const { data } = res?.body;

        // when ODM(enabled)/personalizedOffersResponse is available
        if (
          data?.odmPersonalizedOffersResponse?.personalizedOffersResponse &&
          !responseContainsErrors(data?.odmPersonalizedOffersResponse?.personalizedOffersResponse)
        ) {
          Object.assign(responseObj, {
            personalizedOffersResponse:
              data?.odmPersonalizedOffersResponse?.personalizedOffersResponse,
          });
        }
        // When orderResponse/BrierleyPointsData is available
        if (data.orderResponse) {
          Object.assign(responseObj, { orderResponse: data.orderResponse });
        }
      }
      return responseObj;
    })
    .catch((err) => {
      logger.error(
        `Error in getOffers API call. requestPersonalizedCoupons method: ${err}\nPayload: ${payload}`
      );
    });
}

export function startEddPersist(params, basketId) {
  const payload = {
    body: params,
    webService: {
      ...endpoints.neweddPersist,
      URI: `${endpoints.neweddPersist.URI}/${basketId}`,
    },
  };

  return executeStatefulAPICall(payload)
    .then((res) => {
      return res;
    })
    .catch((err) => {
      logger.error(
        `Error in startEddPersist API call. startEddPersist method: ${err}\nPayload: ${payload}`
      );
      // throw getFormattedError(err);
    });
}

export const getExpressCheckoutData = (isPlcc = false) => {
  return executeStatefulGraphQLQuery({
    query: getExpressCheckoutQuery,
    fetchPolicy: 'no-cache',
    header: { isPlccIC: isPlcc },
  }).then((resp) => {
    if (!resp.data) {
      throw new Error(RES_NULL_ERROR);
    }
    return resp?.data?.expressCheckout;
  });
};
export function moveSFSItemsToSFL(productIds, errorsMapping = []) {
  return executeStatefulGraphQLQuery({
    query: moveItemToSfl,
    variables: {
      request: { c_SFLItems: productIds },
    },
    type: 'mutation',
  })
    .then((resp) => {
      if (!resp.data) {
        throw new Error(`Error in moveSFSItemsToSFL API call`);
      }
      return resp?.data?.moveItemToSfl;
    })
    .catch((err) => {
      logger.error(`Error in moveSFSItemsToSFL API call: ${err}`);
      throw graphQlErrorHandler(err, errorsMapping);
    });
}

export default {
  getShippingMethods,
  getGiftWrappingOptions,
  handleSubmitOrderResponse,
  setShippingMethodAndAddressId,
  submitOrderFn,
  requestPersonalizedCouponsFn,
  startEddPersist,
  moveSFSItemsToSFL,
};
